import { configureStore, combineReducers } from '@reduxjs/toolkit';

// import contracts from '../components/Contracts/reducers/contracts';
import elecContracts from '../components/Contracts/slices/elecContracts';
import gasContracts from '../components/Contracts/slices/gasContracts';
import electricityContractation from "../components/Contractation/reducers/electricityContractation";
import gasContractation from "../components/Contractation/reducers/gasContractation";
import invoices from '../components/Invoices/reducers/invoices';
import invoicesGas from '../components/Invoices/reducers/invoicesGas';
import omip from '@/components/Omip/reducers/omip';

import auth from '../components/Authentication/reducers/auth';
import profile from '../reducers/profile';
import settings from '../components/Settings/reducers/settings';
import payment from '../reducers/payment';
import invoicesMultipoint from '../reducers/invoicesMultipoint';
import reclamATC from '../components/ReclamATC/slices/reclamATC';
import CRM from "../reducers/CRM";
import coupons from "../reducers/coupons";
import virtualBattery from '../components/VirtualBattery/slices/virtualBattery';
import banners from '../reducers/banners';
import featureFlags from '../reducers/featureFlags';
import erpFeatures from '../components/ErpFeatures/slices/erpFeaturesSlice';

const store = configureStore({
  reducer: {
    auth,
    profile,
    settings,
    virtualBattery,
    contracts: combineReducers({
      electricity: elecContracts,
      gas: gasContracts,
    }),
    electricityContractation,
    gasContractation,
    invoices: combineReducers({
      electricity: invoices,
      gas: invoicesGas,
      multipoint: invoicesMultipoint,
    }),
    coupons,
    reclamATC,
    CRMCases: CRM,
    banners,
    featureFlags,
    payment,
    omip,
    erpFeatures,
  },
  // enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(enhancer)
});

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
